import { __ } from '@wordpress/i18n';
import {
	useBlockProps,
	InspectorControls,
	InnerBlocks,
	useInnerBlocksProps,
} from '@wordpress/block-editor';
import { PanelBody } from '@wordpress/components';
import { useEffect } from '@wordpress/element';
import { useSelect, useDispatch } from '@wordpress/data';
import { createBlock } from '@wordpress/blocks';

import Style from './Style';

import metadata from './block.json';
import ColumnAccordion from '../functions/ColumnAccordion.json';

export default function Edit( props ) {
	const { attributes, setAttributes, clientId, isSelected } = props;
	const { blockId } = attributes;
	useEffect( () => {
		if ( ! attributes.blockId || blockId !== clientId ) {
			setAttributes( { blockId: clientId } );
		}
	}, [ clientId ] );
	const { columnsLayout } = attributes; // Get columnsLayout from attributes
	const columnsCount = parseInt( columnsLayout, 10 );
	const blockProps = useBlockProps( {
		className: `alpha-columns-blocks alpha-columns-block-${ blockId }`,
	} );

	const { innerBlocks } = useSelect(
		( select ) => ( {
			innerBlocks: select( 'core/block-editor' ).getBlocks( clientId ),
		} ),

		[ clientId ]
	);

	const { replaceInnerBlocks } = useDispatch( 'core/block-editor' );

	useEffect( () => {
		const newColumnsCount = columnsCount;
		const currentColumnsCount = innerBlocks.length;

		if ( newColumnsCount === currentColumnsCount ) {
			return;
		}

		const newBlocks = [];
		const columnWidth = 100 / newColumnsCount;

		for ( let i = 0; i < newColumnsCount; i++ ) {
			const existingBlock = innerBlocks[ i ];
			const newAttributes = {
				...existingBlock?.attributes,
				columnWidth: {
					desktop: { val: columnWidth.toFixed( 2 ), unit: '%' },
				},
			};

			newBlocks.push(
				createBlock(
					'alpha-blocks/column',
					newAttributes,
					existingBlock ? existingBlock.innerBlocks : []
				)
			);
		}

		replaceInnerBlocks( clientId, newBlocks, false );
	}, [ columnsCount, innerBlocks, clientId, replaceInnerBlocks ] );

	const ALLOWED_BLOCKS = [ 'alpha-blocks/column' ];
	const DEFAULT_BLOCK = {
		name: 'alpha-blocks/column',
	};

	// Calculate column width percentage
	const columnWidthPercentage = ( 100 / columnsCount ).toFixed( 2 );

	// Dynamically generate TEMPLATE based on columnsLayout
	const TEMPLATE = Array.from( { length: columnsCount }, () => [
		'alpha-blocks/column',
		{
			columnWidth: {
				desktop: {
					val: columnWidthPercentage,
					unit: '%',
				},
			},
		},
	] );

	const innerBlocksProps = useInnerBlocksProps( blockProps, {
		template: TEMPLATE,
		directInsert: true,
		orientation: 'horizontal',
		renderAppender: false,
	} );

	return (
		<>
			<Style { ...props } />
			{ isSelected && (
				<window.InspectorGenerator
					props={ props }
					blockJson={ {
						...metadata,
						attributes: {
							...metadata.attributes,
							...ColumnAccordion.attributes,
						},
					} }
				/>
			) }
			<div { ...innerBlocksProps } />
		</>
	);
}
